module.exports = __webpack_public_path__ + "img/camerahead_eval.7c4e4a7b.jpg";